import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

type TriggerLoggingInput = {
  accessToken: string
  loggingManagerRequest: {
    id: string
    name: string
    isAnonymousUser: boolean
    data: any // double check
    occurredAt: string
  }
}

const triggerLoggingManagerEvent = ({ accessToken, loggingManagerRequest }: TriggerLoggingInput) =>
  fetch(
    accessToken,
    `${endpoint('loggingmanager')}/log`,
    loggingManagerRequest,
    'POST',
    'no-cache',
    { 'Content-Type': 'application/json' },
  )

export { triggerLoggingManagerEvent }
